<template>
  <div class="ratio-container">
    <div class="ratio-group">
      <div
        v-for="(item, index) in crop_ratio"
        :key="item.label"
        :style="{backgroundImage: `url(${item.url})`}"
        @click="cropByRatio(item.widthRatio, item.heightRatio, index)"
        :class="['ratio-item', { active: index == currentButtonIndex }]"
      >
        {{ item.label }}
      </div>
    </div>
    <div class="custom-ratio">
      <label class="title-label">指定比例</label>
      <div>
        <el-input 
          v-model.trim.number="customWidthRatio"
          @change="changeCustomRatio"
          @keyup.enter.native="changeCustomRatio" 
        >
          <i slot="suffix" style="line-height: 34px">宽</i>
          </el-input>
      </div>
      <div style="display:inline-block;width:5px;color: #d2d5dd;">:</div>
      <div>
        <el-input 
          v-model.trim.number="customHeightRatio"
          @change="changeCustomRatio"
          @keyup.enter.native="changeCustomRatio"
        >
          <i slot="suffix" style="line-height:34px;">高</i>
        </el-input>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: [ 'cropper', 'currentImage'],
  data () {
    return {
      customWidthRatio: null,
      customHeightRatio: null,
      currentButtonIndex: null,
      cropMode: '',
      crop_ratio: [
        { label: '1:1', widthRatio: 1, heightRatio: 1, url: require('@/assets/images/page/crop/one-to-one.png')},
        { label: '2:3', widthRatio: 2, heightRatio: 3, url: require('@/assets/images/page/crop/two-to-three.png')},
        { label: '3:2', widthRatio: 3, heightRatio: 2, url: require('@/assets/images/page/crop/three-to-two.png')},
        { label: '3:4', widthRatio: 3, heightRatio: 4, url: require('@/assets/images/page/crop/three-to-four.png')},
        { label: '4:3', widthRatio: 4, heightRatio: 3, url: require('@/assets/images/page/crop/four-to-three.png')},
        { label: '4:5', widthRatio: 4, heightRatio: 5, url: require('@/assets/images/page/crop/four-to-five.png')},
        { label: '5:4', widthRatio: 5, heightRatio: 4, url: require('@/assets/images/page/crop/five-to-four.png')},
        { label: '5:7', widthRatio: 5, heightRatio: 7, url: require('@/assets/images/page/crop/five-to-seven.png')},
        { label: '7:5', widthRatio: 7, heightRatio: 5, url: require('@/assets/images/page/crop/seven-to-five.png')},
        { label: '9:16', widthRatio: 9, heightRatio: 16, url: require('@/assets/images/page/crop/nine-to-sixteen.png')},
        { label: '16:9', widthRatio: 16, heightRatio: 9, url: require('@/assets/images/page/crop/sixteen-to-nine.png')},
        { label: '自由', widthRatio: NaN, heightRatio: NaN, url: require('@/assets/images/page/crop/free.png')},
      ]
    }
  },
  watch: {
    'customWidthRatio'() {
      if (!this.customWidthRatio) {
        this.$message.error('宽度比/高度比不允许为0或为空');
      }
    },
    'customHeightRatio'() {
      if (!this.customHeightRatio) {
        this.$message.error('宽度比/高度比不允许为0或为空');
      }
    }
  },
  methods: {
    // 指定比例
    changeCustomRatio () {
      if (!this.customWidthRatio || !this.customHeightRatio) {
        return;
      }
      this.currentButtonIndex = null;
      this.cropMode = '';

      this.cropper.crop();
      this.cropper.setAspectRatio(this.customWidthRatio / this.customHeightRatio);
    },

    // 常用尺寸
    cropByRatio (widthRatio, heightRatio, index) {
      this.cropMode = '';
      this.cropper.crop();

      if (widthRatio == NaN) {
        this.cropper.setAspectRatio(NaN);
      } else {
        this.cropper.setAspectRatio(widthRatio / heightRatio);
      }
      
      this.currentButtonIndex = index;
      // 当点击上面的常用比例时，自定义比例清空
      if (this.customWidthRatio || this.customHeightRatio) {
        this.customWidthRatio = null;
        this.customHeightRatio = null;
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.ratio-container {
  .title-label {
    font-size: 14px;
    line-height: 40px;
    width: 60px;
    font-weight: 400;
    margin-right: 6px;
  }
  
  .ratio-group {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    padding: 10px 10px 10px 11px;
    box-shadow: 0px 2px 6px 0px rgba(0,0,0,0.4);
    border-radius: 5px;
    margin: 0 10px;
    .ratio-item {
      width: 72px;
      height: 72px;
      line-height: 72px;
      text-align: center;
      flex-shrink: 1;
      background-size: auto;
      background-repeat: no-repeat;
      background-position: center;
      background-color: #F3F5F7;
      border-radius: 5px;
      font-size: 13px;
      border: 1px solid #F3F5F7;
      cursor: pointer;
    }

    .ratio-item.active {
      border-color: #3388FF;
    }
  }

  .custom-ratio {
    padding: 25px 0 10px 11px;
    div {
      width: 87px;
      display: inline-block;
    }
    /deep/ .el-input {
      .el-input__inner {
        height: 35px;
        line-height: 35px;
        padding: 0 10px;
      }
    }
  }

  @media screen and (max-height: 820px) {
    .ratio-group {
      gap: 6px;
      padding: 6px 6px 6px 7px;
    }

    .custom-ratio div {
      width: 80px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/images/crop/commonRatio/index.vue